import { GET_DOCTORS_ACTIONS } from './constants';

export const getDoctors = (payload: any) => ({
  type: GET_DOCTORS_ACTIONS.START,
  payload,
});

export const getDoctorsFail = (error: any) => ({
  type: GET_DOCTORS_ACTIONS.FAIL,
  error,
});

export const getDoctorsSuccess = (data: any) => ({
  type: GET_DOCTORS_ACTIONS.SUCCESS,
  data,
});

export const getDoctorsReset = () => ({
  type: GET_DOCTORS_ACTIONS.RESET,
});
